

























import { ProsemirrorHelper } from '@getaccept/editor-lib';
import type { Field, MergeValues } from '@getaccept/editor-lib';
import type { PropType } from '@vue/composition-api';
import { watch, computed, defineComponent } from '@vue/composition-api';
import ProsemirrorViewerFormInput from './ProsemirrorViewerFormInput.vue';

export default defineComponent({
  name: 'InputCheckbox',
  components: {
    ProsemirrorViewerFormInput,
  },
  props: {
    checked: { type: Boolean },
    hasUpdateError: { type: Boolean },
    isUpdating: { type: Boolean },
    editable: { type: Boolean },
    fields: { type: Array as PropType<Field[]>, default: () => [] },
    fieldFocused: { type: Boolean },
    input: { type: Object as PropType<Field>, default: () => ({}) },
    isPdfViewer: { type: Boolean },
    mergeValues: { type: Object as PropType<MergeValues>, default: () => ({}) },
  },
  setup(props) {
    const isDisabled = computed(() => !props.editable && !props.isPdfViewer);

    watch(
      () => props.fieldFocused,
      fieldFocused => {
        if (fieldFocused) {
          const input: HTMLInputElement = document.getElementById(
            props.input.id
          ) as HTMLInputElement;
          input.focus({
            preventScroll: true,
          });
        }
      }
    );

    return {
      isDisabled,
      getSafeText: ProsemirrorHelper.getSafeText,
    };
  },
});
